module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_8004.de02d1f8.png";